import script from "./FlyingTiger-Purchases.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyingTiger-Purchases.vue?vue&type=script&setup=true&lang=js"

import "./FlyingTiger-Purchases.vue?vue&type=style&index=0&id=277ec119&lang=css"
import "./FlyingTiger-Purchases.vue?vue&type=style&index=1&id=277ec119&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-277ec119"]])

export default __exports__